import { useLocation } from 'react-router-dom';
import { BreadcrumbLocationState } from 'helpers/vault-breadcrumbs';

// The breadcrumb origin the previous screen passed along in the location
// state, if any (see `withOrigin`). Undefined on reload or deep link.
export const useBreadcrumbOrigin = () =>
  useLocation<BreadcrumbLocationState | undefined>().state?.breadcrumbOrigin;
